<script>
import DetectSteps from '../Steps/DetectSteps.vue'
import NetworkAndDevice from './NetworkAndDevice.vue'
import WebCam from './WebCam.vue'
import Microphone from './Microphone.vue'

import WifiIcon from '../assets/wifi.svg'
import MicrophoneIcon from '../assets/microphone.svg'
import WebcamIcon from '../assets/webcam.svg'
import { getMicrophoneErrorText } from '../helper/deviceDetect.helper'

export default {
  components: {
    DetectSteps,
    NetworkAndDevice,
    WebCam,
    Microphone
  },
  props: {
    isOpenNetworkAndDevice: {
      type: Boolean,
      default: false
    },
    isOpenCamera: {
      type: Boolean,
      default: false
    },
    isOpenMic: {
      type: Boolean,
      default: false
    }
  },
  inject: ['setDetectInfo'],
  data() {
    return {
      activeStep: 1,
      stepOneFinish: false,
      deviceStatus: undefined,
      webCameraStatus: undefined,
      microphoneStatus: undefined,
      /** start --- 设备环境检测相关属性 */
      isRefreshDetect: false,
      /** end --- 设备环境检测相关属性 */
      /** ----------------------------------- */
      /** start --- 摄像头检测相关属性 */
      isCameraPlaySuccess: false, // 摄像头是否顺利走完了播放流程，如果走完了则展示 看得到 和 看不到按钮，如果没走完在播放框里展示错误信息
      isCameraPlayFail: false, // 摄像头播放流程是否失败
      isCameraCanBeSeen: undefined, // 用户是否点击了看得到或者看不到按钮
      webCamInitFinish: false, // 摄像头是否初始化完成
      /** end --- 摄像头检测相关属性 */
      /** ----------------------------------- */
      /** start --- 麦克风检测相关属性 */
      isMicrophoneDetectFinish: false, // 麦克风检测是否完成
      isMicrophonePass: false, // 麦克风检测是否通过
      isMicrophoneFail: false, // 麦克风检测是否失败
      /** end --- 麦克风检测相关属性 */
      /** ----------------------------------- */

      WifiIcon,
      MicrophoneIcon,
      WebcamIcon
    }
  },
  methods: {
    handleDeviceDetect(isPass) {
      if (isPass) {
        this.deviceStatus = 'success'
      } else {
        this.deviceStatus = 'fail'
      }
      this.stepOneFinish = true
    },
    handleNestStep() {
      if (this.activeStep === this.detectSteps.length) {
        return
      }
      this.activeStep++
    },
    handleRefreshDetect() {
      this.isRefreshDetect = true
      this.deviceStatus = undefined
      this.stepOneFinish = false
      setTimeout(() => {
        this.isRefreshDetect = false
      }, 500)
    },
    async handOpenCamera() {
      try {
        if (Array.isArray(this.$refs.webCam)) {
          await this.$refs.webCam[0].openVideo()
        } else {
          await this.$refs.webCam.openVideo()
        }
        this.isCameraPlaySuccess = true
      } catch (error) {
        this.isCameraPlayFail = true
      }
    },
    handleCameraPass() {
      this.webCameraStatus = 'success'
      this.handleNestStep()
    },
    handleCameraGetDeviceError() {
      this.webCameraStatus = 'fail'
    },
    handleCameraFail() {
      this.webCameraStatus = 'fail'
      this.setDetectInfo({
        camera: {
          result: '摄像头播放失败',
          isPass: false
        }
      })
      this.handleNestStep()
    },
    handleMicrophoneRecordError(errorCode) {
      this.isMicrophoneFail = true
      const errorText = getMicrophoneErrorText(errorCode)
      this.setDetectInfo({
        microphone: {
          result: errorText,
          isPass: false,
          errorCode
        }
      })
    },
    handleMicrophoneCanHear() {
      this.microphoneStatus = 'success'
      this.handleNestStep()
      this.setDetectInfo({
        microphone: {
          result: '通过',
          isPass: true
        }
      })
    },
    handleMicrophoneCantHear() {
      this.microphoneStatus = 'fail'
      this.handleNestStep()
      this.setDetectInfo({
        microphone: {
          result: '麦克风录制声音听不到',
          isPass: false
        }
      })
    },
    handleMicrophoneCanJumpToNextStep() {
      this.microphoneStatus = 'fail'
      this.handleNestStep()
    },
    handleDeviceInitFinish() {
      this.webCamInitFinish = true
    }
  },
  mounted() {
    this.$watch(() => {
      const detectInfos = {
        isAllFinish: true,
        isAllPass: true
      }

      this.detectSteps.forEach((step) => {
        if (step.status === undefined) {
          detectInfos.isAllFinish = false
        } else if (step.status === 'fail') {
          detectInfos.isAllPass = false
          detectInfos.isAllFinish = detectInfos.isAllFinish && true
        } else if (step.status === 'success') {
          detectInfos.isAllPass = detectInfos.isAllPass && true
          detectInfos.isAllFinish = detectInfos.isAllFinish && true
        }
      })

      if (detectInfos.isAllFinish) {
        this.$emit('detect-finish', detectInfos.isAllPass)
      }
    })
  },
  computed: {
    detectSteps() {
      const initialDetectSteps = [
        {
          name: '网络设备检测',
          status: this.deviceStatus,
          icon: this.WifiIcon
        },
        {
          name: '摄像头检测',
          status: this.webCameraStatus,
          icon: this.WebcamIcon
        },
        {
          name: '麦克风检测',
          status: this.microphoneStatus,
          icon: this.MicrophoneIcon
        }
      ]

      if (!this.isOpenNetworkAndDevice) {
        initialDetectSteps.shift()
      }
      if (!this.isOpenCamera) {
        initialDetectSteps.splice(1, 1)
      }
      if (!this.isOpenMic) {
        initialDetectSteps.pop()
      }

      return initialDetectSteps
    }
  }
}
</script>
<template>
  <div class="detect-box">
    <div class="detect-box-content">
      <DetectSteps :active="activeStep" :steps="detectSteps" />

      <template v-for="(step, idx) in detectSteps">
        <NetworkAndDevice
          :key="step.name"
          v-if="
            activeStep === idx + 1 &&
            step.name === '网络设备检测' &&
            !isRefreshDetect
          "
          @detect-finish="handleDeviceDetect"
        />
        <WebCam
          :key="step.name"
          ref="webCam"
          @device-error="handleCameraGetDeviceError"
          @device-init-finish="handleDeviceInitFinish"
          v-if="activeStep === idx + 1 && step.name === '摄像头检测'"
        />
        <Microphone
          :key="step.name"
          v-if="activeStep === idx + 1 && step.name === '麦克风检测'"
          @record-finsh="isMicrophoneDetectFinish = true"
          @record-error="handleMicrophoneRecordError"
        />
      </template>
    </div>
    <div
      v-if="detectSteps[activeStep - 1].name === '网络设备检测'"
      class="device-detect-btns"
    >
      <button
        v-if="deviceStatus === 'fail'"
        class="btn-outline"
        style="margin-right: 20px"
        @click="handleRefreshDetect"
      >
        重新检测
      </button>
      <button
        class="btn"
        :class="{
          'btn-disabled': !stepOneFinish,
          'btn-single': deviceStatus !== 'fail'
        }"
        @click="handleNestStep"
      >
        下一步
      </button>
    </div>
    <div
      v-if="detectSteps[activeStep - 1].name === '摄像头检测'"
      class="device-detect-btns"
    >
      <button
        v-if="
          !isCameraPlayFail &&
          !isCameraPlaySuccess &&
          webCameraStatus !== 'fail'
        "
        class="btn btn-single"
        :style="{
          display: !webCamInitFinish ? 'none' : 'block'
        }"
        @click="handOpenCamera"
      >
        授权启用摄像头和麦克风
      </button>
      <button
        @click="handleCameraFail"
        v-if="isCameraPlayFail || webCameraStatus === 'fail'"
        class="btn btn-single"
      >
        跳过
      </button>

      <button
        v-if="isCameraPlaySuccess"
        class="btn-outline"
        style="margin-right: 20px"
        @click="handleCameraFail"
      >
        看不到
      </button>
      <button v-if="isCameraPlaySuccess" class="btn" @click="handleCameraPass">
        看的到
      </button>
    </div>
    <div
      v-if="detectSteps[activeStep - 1].name === '麦克风检测'"
      class="device-detect-btns"
    >
      <button
        @click="handleMicrophoneCanJumpToNextStep"
        v-if="isMicrophoneFail && !isMicrophoneDetectFinish"
        class="btn btn-single"
      >
        跳过
      </button>

      <button
        v-if="isMicrophoneDetectFinish"
        class="btn-outline"
        style="margin-right: 20px"
        @click="handleMicrophoneCantHear"
      >
        听不到
      </button>
      <button
        v-if="isMicrophoneDetectFinish"
        @click="handleMicrophoneCanHear"
        class="btn"
      >
        听得到
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.detect-box {
  width: 760px;
  margin: auto;
  margin-top: 50px;
  padding-bottom: 40px;
}
.detect-box-content {
  background-color: #f7faffff;
  border-radius: 12px;
  width: 760px;
  min-height: 339px;
  margin: auto;
  margin-top: 15px;
  display: flex;
  padding: 32px 24px 32px 108px;
  margin-bottom: 40px;
}
.btn {
  width: 184px;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  border: none;
  background: linear-gradient(96deg, #329dfc 0%, #397efd 100%);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.btn:hover {
  background: linear-gradient(96deg, #329dfc 0%, #397efd 100%);
  opacity: 0.8;
}
.btn:active {
  background: linear-gradient(96deg, #0d8dff 0%, #005aff 100%);
}
.btn-single {
  width: 340px;
}
.btn-disabled {
  background-color: #cbcfdfff;
  background: none;
  color: #ffffff;
  cursor: not-allowed;
  pointer-events: none;
}

.btn-outline {
  width: 184px;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  border: 1px solid #155eef;
  background-color: transparent;
  color: #155eef;
  font-size: 16px;
  cursor: pointer;
}
.btn-outline:hover {
  border: 1px solid #597ef7ff;
  color: #597ef7ff;
}
.btn-outline:active {
  border: 1px solid #1d39c4ff;
  color: #1d39c4ff;
}
.device-detect-btns {
  display: flex;
  justify-content: center;
}
</style>
